<template>
  <div @keyup.enter.prevent="proceed">
    <div>
      <StepTitle :value="mainStore.currentStepContent.title || 'Quel est votre budget&nbsp;?'" class="mb-8" />

      <div class="form-group" :class="{ 'form-group-invalid': hasErrors }">
        <span class="mb-2 block px-0.5 text-body-color">{{ label }}</span>

        <div class="flex bg-gray-100 rounded-lg p-1 mb-4 w-fit">
          <div class="flex gap-x-1">
            <label v-for="type in budgetKinds" :key="type.value" class="relative cursor-pointer m-0 p-0">
              <input
                v-model="selectedBudgetKind"
                type="radio"
                :value="type.value"
                class="peer sr-only"
                @change="onBudgetKindChange"
              />
              <div
                class="peer-checked:bg-white peer-checked:text-gray-700 bg-transparent text-gray-500 hover:text-gray-700 py-1 px-4 inline-flex items-center text-sm font-medium rounded-lg transition-all duration-200"
              >
                {{ type.label }}
              </div>
            </label>
          </div>
        </div>

        <label
          v-for="range in currentBudgetRanges"
          :id="'fast-project-budget-' + range.value"
          :key="range.value"
          class="mb-2 flex cursor-pointer items-center justify-between rounded-lg p-4"
          :class="[
            budget === range.value
              ? 'bg-brand bg-opacity-10 text-brand'
              : 'bg-slate-100 text-body-color hover:bg-brand hover:bg-opacity-10'
          ]"
        >
          <input v-model="budget" type="radio" name="project[budget]" :value="range.value" class="hidden" />
          {{ range.label }}
          <span v-if="budget === range.value" key="check">
            <fa-icon type="fas" icon="check-circle" />
          </span>
          <span v-else key="circle" class="text-gray-400">
            <fa-icon type="far" icon="circle" />
          </span>
        </label>
        <div v-if="hasErrors" class="invalid-feedback mb-3 mt-1">
          Votre budget {{ mainStore.errors.budget | toSentence }}.
        </div>
      </div>
    </div>

    <div v-html="mainStore.currentStepContent.reassurance"></div>

    <portal v-if="active" to="fast-footer">
      <StepNav :next-disabled="!completed" @goToPrev="mainStore.goToPreviousStep()" @goToNext="proceed" />
    </portal>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'

import StepTitle from './StepTitle.vue'
import StepNav from './StepNav.vue'

export default {
  components: {
    StepTitle,
    StepNav
  },
  data() {
    return {
      budget: null,
      selectedBudgetKind: 'global',
      budgetKinds: [
        { value: 'global', label: 'Budget global' },
        { value: 'daily_rate', label: 'Tarif journalier' }
      ],
      globalBudgetRanges: [
        { value: '250', label: 'Moins de 500 €' },
        { value: '750', label: '500 à 1 000 €' },
        { value: '4500', label: '1 000 à 10 000 €' },
        { value: '15000', label: '10 000 € et plus' }
      ],
      dailyRateBudgetRanges: [
        { value: '250', label: 'Moins de 200 €' },
        { value: '750', label: '200 à 500 €' },
        { value: '4500', label: '500 à 800 €' },
        { value: '15000', label: 'Plus de 800 €' }
      ]
    }
  },
  computed: {
    ...mapStores(useMainStore),
    active() {
      return this.mainStore.step === STEPS.budget
    },
    label() {
      return this.mainStore.stepContent(STEPS.budget).label
    },
    completed() {
      return this.budget !== null && typeof this.budget !== 'undefined'
    },
    hasErrors() {
      return this.mainStore.errors.budget?.length > 0
    },
    currentBudgetRanges() {
      return this.selectedBudgetKind === 'global' ? this.globalBudgetRanges : this.dailyRateBudgetRanges
    }
  },
  watch: {
    budget(val) {
      if (val) this.proceed()
    }
  },
  methods: {
    enter() {
      this.$root.sendMatomoPageView('budget')
      document.addEventListener('keyup', this.proceedByKeyboard)
    },
    exit() {
      document.removeEventListener('keyup', this.proceedByKeyboard)
    },
    proceedByKeyboard(event) {
      if (event.key === 'Enter' && this.completed) {
        this.proceed()
      }
    },
    onBudgetKindChange() {
      this.budget = null
    },
    proceed() {
      if (!this.completed) return

      this.mainStore.requestBody.project.budget = this.budget
      this.mainStore.requestBody.project.budget_kind = this.selectedBudgetKind
      this.mainStore.goToNextStep()
    }
  }
}
</script>
